import { Button } from '@/components/UI';
import styles from './DialogActions.module.css';

interface DialogActionsProps {
  cancelLabel?: string;
  confirmLabel: string;
  onCancel?: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
}

export function DialogActions({
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  confirmLoading = false,
}: DialogActionsProps) {
  return (
    <div className={styles.actions}>
      {cancelLabel && onCancel ? (
        <Button type="button" variant="outline" onClick={onCancel}>
          {cancelLabel}
        </Button>
      ) : null}
      <Button
        type="button"
        variant="primary"
        onClick={onConfirm}
        disabled={confirmDisabled}
        loading={confirmLoading}
      >
        {confirmLabel}
      </Button>
    </div>
  );
}
